import React from "react";
import { motion } from "framer-motion";
import {
  Cake,
  PartyPopper,
  Heart,
  GraduationCap,
  Sun,
  Users,
  Building2,
  Gift,
} from "lucide-react";

const EVENTS = [
  { icon: Cake, title: "Anniversaires", sub: "Adultes & enfants" },
  { icon: PartyPopper, title: "EVG", sub: "Enterrement de vie de garçon" },
  { icon: Heart, title: "EVJF", sub: "Enterrement de vie de jeune fille" },
  { icon: GraduationCap, title: "Intégrations", sub: "Lycée & université" },
  { icon: Sun, title: "Centres aérés", sub: "Sorties enfants encadrées" },
  { icon: Users, title: "Sorties de groupes", sub: "Familles, amis, asso" },
  { icon: Building2, title: "Comités d'entreprise", sub: "Team building Fougères" },
  { icon: Gift, title: "Cartes cadeaux", sub: "Offrir une session" },
];

const RIBBON = [
  "ANNIVERSAIRES",
  "EVG · BRETAGNE",
  "EVJF",
  "TEAM BUILDING",
  "COMITÉS D'ENTREPRISE",
  "CENTRES AÉRÉS",
  "INTÉGRATIONS LYCÉE",
  "SORTIES DE GROUPES",
];

export default function Events() {
  return (
    <section
      id="evenements"
      data-testid="events-section"
      className="relative bg-black text-white py-20 md:py-28 lg:py-32 overflow-hidden"
    >
      {/* Marquee ribbon top */}
      <div className="absolute top-0 inset-x-0 overflow-hidden bg-[#E91E63] border-y-2 border-black py-3">
        <div className="flex gap-12 animate-marquee whitespace-nowrap">
          {[...RIBBON, ...RIBBON, ...RIBBON].map((r, i) => (
            <span
              key={i}
              className="font-display text-lg md:text-2xl font-bold uppercase tracking-tight text-white"
            >
              {r}
              <span className="mx-6 text-[#FFEB3B]">★</span>
            </span>
          ))}
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-16 md:pt-20">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-12 md:mb-16">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#FFEB3B] mb-3">
              04 — Pour quels événements ?
            </p>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold uppercase leading-[0.9] tracking-tight">
              L&apos;organisateur de
              <br />
              <span className="text-[#E91E63]">tous vos événements</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-base md:text-lg text-white/70 leading-relaxed">
              Paintball Aventures 35 est l&apos;organisateur idéal pour vos anniversaires, EVG, EVJF, journées d&apos;intégration, centres aérés, sorties de groupes et comités d&apos;entreprise. Une activité fun, sécurisée et fédératrice en pleine nature.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/15 border border-white/15">
          {EVENTS.map((e, i) => (
            <motion.div
              key={e.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`event-card-${e.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group relative bg-black hover:bg-[#E91E63] transition-colors duration-300 p-6 md:p-8 cursor-default"
            >
              <e.icon
                className="w-7 h-7 md:w-8 md:h-8 text-[#E91E63] group-hover:text-white mb-5 transition-colors"
                strokeWidth={2}
              />
              <p className="font-display text-lg md:text-xl font-bold uppercase leading-tight">
                {e.title}
              </p>
              <p className="text-xs md:text-sm text-white/60 group-hover:text-white/90 mt-2 transition-colors">
                {e.sub}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
